<template>
<v-container>
  <h1>Ihre Einkäufe</h1>
  <v-container>
    <v-data-table v-bind:headers="headers" :items="invoices" v-bind:pagination.sync="pagination" :rows-per-page-text="'Aufträge pro Seite'" :no-data-text="'Keine Aufträge vorhanden'" class="elevation-3">
      <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ moment(props.item.invoice_date).format('L') }}</td>
          <td class="text-xs-right">{{ props.item.invoice_nr }}</td>
          <td>{{ props.item.invoice_type == 2 ? 'Kassenbon' : 'Rechnung' }}</td>
          <td class="text-xs-right">{{ props.item.total.replace('.', ',') }} €</td>
          <td class="text-xs-right"><a @click="invoiceDownload(props.item.invoice_id)">herunterladen</a></td>
        </template>
    </v-data-table>
  </v-container>
  <h2>Fehlt ein Einkauf?</h2>
  <v-container>
    Bitte Kassenbon-Nummer eintragen:<br/> oder schreiben Sie uns eine Nachricht:<br/>
  </v-container>
</v-container>
</template>
<script>
import moment from 'moment'
moment.locale('de')

export default {
  data() {
    return {
      headers: [{
        text: 'Belegdatum',
        value: 'invoice_date'
      }, {
        text: 'Belegnummer',
        value: 'invoice_nr',
        align: 'right'
      }, {
        text: 'Belegtyp',
        value: 'invoice_type',
        align: 'left'
      }, {
        text: 'Betrag',
        value: 'total',
        align: 'right'
      }, {
        text: 'Beleg herunterladen',
        sortable: false
      }],
      invoices: [],
      pagination: {
        sortBy: 'invoice_date',
        descending: true,
        rowsPerPage: 10
      },
      moment: moment
    }
  },
  created() {
    this.$api.order.findInvoice().then((response) => {
      this.invoices = response.data
    })
  },
  methods: {
    invoiceDownload: function(invoiceId) {
      this.$api.order.invoiceDownload({
        invoice_id: invoiceId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderOverview.vue?4ff941f4